export default __webpack_public_path__ + "static/media/chef.9bb6e922.svg";